import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export const NotFoundState: React.FC = () => {
  return (
    <div className="w-full min-h-screen">
      <div className="max-w-7xl mx-auto space-y-6 font-manrope px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center">
          <Link to="/clients">
            <Button variant="ghost" size="sm" className="gap-1">
              <ArrowLeft className="h-4 w-4" /> Back to Clients
            </Button>
          </Link>
        </div>
        <div className="text-center py-8">
          <h2 className="text-2xl font-semibold">Client Not Found</h2>
          <p className="text-gray-500 mt-2">The client you're looking for doesn't exist.</p>
        </div>
      </div>
    </div>
  );
};
